<template>
  <div class="w-full mt-5 flex flex-col border-0 p-0">
    <label
      :for="id"
      v-if="label"
      class="mb-2 text-xs md:text-xs text-left text-gray-500 text-opacity-80"
      :class="{ 'text-red-500': invalid }"
      ><b>{{ label }}</b
      ><span v-if="required" class="text-red-500">*</span></label
    >
    <p v-if="sublabel" class="text-xs text-gray-400 text-left mb-2">
      {{ sublabel }}
    </p>
    <a-select
      :disabled="disabled"
      :mode="mode"
      size="large"
      :placeholder="placeholder ? placeholder : 'Seleccionar'"
      show-search
      option-filter-prop="children"
      :class="{ 'border-red-500': invalid }"
      class="uppercase"
      :filter-option="filterOption"
      :value="value"
      @change="handleChange"
      :loading="loading"
      :aria-label="label"
      :aria-required="required"
      aria-haspopup="listbox"
      role="combobox"
      :aria-controls="id ? id + '-listbox' : undefined"
      :aria-activedescendant="activeOptionId"
      :aria-expanded="isExpanded"
      @dropdownVisibleChange="onOpenChange"
      ref="select"
      @keydown.native.capture="onKeyDown"
    >
      <a-select-option
        id="option-seleccionar"
        value=""
        role="option"
        class="text-gray-400 font-normal"
        :aria-selected="value === '' || value == null"
      >
        Seleccionar

        <label for="option-seleccionar" class="sr-only"> Seleccionar </label>
      </a-select-option>
      <a-select-option         
        :id="`option-${option.name}`"
        data-bs-toggle="tooltip"
        :title="option.name"
        v-for="option in selectOptions"
        role="option"
        style="text-align: center"
        :value="`${option.id}`"
        :key="option.id"
        class="uppercase"
        :aria-selected="value == option.id"
        @mouseenter="handleActiveOption(`option-${option.name}`)"
      >
        {{ option.name }}
      </a-select-option>
    </a-select>

    <div class="sr-only" aria-live="assertive" aria-atomic="true">
      {{ selectedValueAria }}
    </div>

    <!-- Lectura dinámica de opción enfocada -->
    <div class="sr-only" aria-live="assertive" aria-atomic="true">
      {{ focusedOptionName }}
    </div>

    <p
      v-if="invalid"
      class="mt-2 text-left text-xs text-red-500"
      aria-live="polite"
    >
      Este campo es obligatorio
    </p> 
  </div>
</template>

<script>
import Modal from "@/components/UI/Modal.vue";

export default {
  components: {
    Modal,
  },
  props: [
    "id",
    "selectOptions",
    "label",
    "required",
    "value",
    "mode",
    "placeholder",
    "loading",
    "disabled",
    "getObjectValue",
    "sublabel",
  ],
  data() {
    return {
      invalid: false,       
      activeOptionId: "",
      isExpanded: false,
      focusedOptionName: ""
    };
  },
  methods: {  
    onKeyDown(e) {
      // Lógica existente para flechas

      if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        this.$nextTick(() => {
          const active = document.querySelector(
            ".ant-select-dropdown .ant-select-dropdown-menu-item-active"
          );
          if (active) {             
            const focusOptionName = active.id.replace("option-", "");

            let index = this.selectOptions.findIndex(
              (option) => String(option.name) === String(focusOptionName)
            );

            let optionName = {};
            if (index === -1) {
              if (e.key === "ArrowDown") {
                optionName = this.selectOptions[0];
              }
              if (e.key === "ArrowUp") {
                optionName = this.selectOptions[this.selectOptions.length - 1];
              }
            }

            let indexselected = null;
            if (index !== -1) {
              if (e.key === "ArrowDown") {
                indexselected = index + 1;
              }
              if (e.key === "ArrowUp") {
                indexselected = index - 1;
              }
              optionName = this.selectOptions[indexselected];
            }
             
            if (optionName === undefined) {
              optionName = {
                name: "Seleccionar",
              };
            }

            this.focusedOptionName = this.label + " " + optionName.name;             
          }
        });
      }
    },

    handleActiveOption(id) {
      this.activeOptionId = id;
    },
    handleChange(value) {
      const selectedOption = this.selectOptions.find(
        (option) => option.id == value
      );       
      if (this.getObjectValue) {
        this.$emit(
          "change",
          this.selectOptions.find((option) => option.id == value)
        );
        this.$emit("input", value);
      } else {
        this.$emit("input", value);
        this.$emit("change", value);
      }
      this.$emit(
        "response",
        this.selectOptions.find((option) => option.id == value)
      );
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    setInvalid(invalid) {
      if (this.required) {
        this.invalid = invalid;
      }
    }, 
    onOpenChange(open) {
      this.isExpanded = open;
      if (open && this.id) {
        // Asigna un ID único al listbox desplegable para que aria-controls pueda encontrarlo.
        this.$nextTick(() => {
          // Asumimos que solo un dropdown puede estar abierto a la vez.
          const listbox = document.querySelector(
            ".ant-select-dropdown:not([id])"
          );
          if (listbox) {
            listbox.id = this.id + "-listbox";
            listbox.setAttribute("role", "listbox");
          }
        });
      }
    },
  },
  computed: {
    selectedValueAria() {
      let result = "";
      if (
        !this.value ||
        !this.selectOptions ||
        this.selectOptions.length === 0
      ) {
        result = this.label + " " + "ninguna seleccionada";
        return result;
      }
      const selectedOption = this.selectOptions.find(
        (option) => String(option.id) === String(this.value)
      );
      result =
        this.label + " " + (selectedOption ? selectedOption.name : "ninguna") + " seleccionado";
      return result;
    },
  },
  watch: {
    value: function (value) {
      if (value == "" && this.required) {
        this.invalid = true;
      } else {
        this.invalid = false;
      }
    },
  },
};
</script>

<style scoped>
.ant-select-selection__placeholder {
  text-align: center !important;
}

.ant-select-selection-selected-value {
  text-align: center !important;
  float: none !important;
}

.ant-select-selection {
  float: none !important;
  text-align: center !important;
  justify-content: center !important;
}

.ant-select-selection--single {
  height: 40px;
}
</style>
